var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notificationCenter"}},_vm._l((this.$store.state.notifStore.notifications),function(item,index){return _c('alert-notification',{key:index,attrs:{"message":item.message,"type":item.type,"time":item.time}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }